import { Box, Divider, Stack } from '@mui/material';
import { IncButtonLight } from 'components/inc-button/inc-button.styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectOrderItems, selectSlug } from 'redux/cart/cart.selectors';
import CheckoutSection from '../checkout-section/checkout-section.component';
import SummaryItem from './summary-item/summary-item.component';

const CheckoutItemsSection = ({ ...rest }) => {
  const { t } = useTranslation();
  const items = useSelector(selectOrderItems);
  const storeSlug = useSelector(selectSlug);

  return items?.length ? (
    <CheckoutSection
      title={t('checkout.items.title')}
      data-testid="CheckoutItemsSection.CheckoutSection"
      {...rest}
    >
      <Stack
        spacing={1}
        divider={<Divider />}
        component="ul"
        sx={{ padding: 0, margin: 0, listStyle: 'none' }}
      >
        {items.map((item, i) => (
          <Box component="li" key={`overview-${item.orderItemId}`}>
            <SummaryItem item={item} />
          </Box>
        ))}
      </Stack>
      <Box mt={[2, 2, 1]}>
        <IncButtonLight
          fullWidth
          component={Link}
          to={`/locations/${storeSlug}/menu`}
          data-testid="CheckoutItemsSection.IncButtonLight.AddMore"
        >
          {t('checkout.items.addMoreItems')}
        </IncButtonLight>
      </Box>
    </CheckoutSection>
  ) : null;
};

export default CheckoutItemsSection;
